import { ShopChannel } from './constant';

const SLCommon = Mach.requireModule('SLCommon');
// 独立出来给预请求使用，防止引入service文件的i18nClient，导致sharedworder打包失败
let currentChannel = '';
export const CommonHeaders = {
  updateChannel(channel) {
    currentChannel = channel;
  },

  isSpecialChannel() {
    const { channel } = SLCommon?.getEnv?.() || {};
    return channel === ShopChannel.BD //场景：全供给包
        || currentChannel === ShopChannel.BD
        || currentChannel === ShopChannel.OPEN
        || currentChannel === ShopChannel.MERCHANT //场景：复用到B端
        || currentChannel === ShopChannel.PARTNER; //场景：复用到B Partner端
  },

  getCommonHeader() {
    if (currentChannel) {
      return {
        channel: currentChannel
      };
    } else {
      return {};
    }
  }
};
